
import { InlineWidget } from 'react-calendly';

export function InlineWidgetClient() {
  return (
    <InlineWidget
      pageSettings={{
        hideEventTypeDetails: true,
      }}
      url="https://calendly.com/flagsync/15min"
    />
  );
}
